import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function BundleSection() {
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  const items = [{
    text: 'Manual Maestro Protocolo Cero Gritos',
    value: '(Valor real 27€)'
  }, {
    text: 'Bono GRATIS: Guía SOS Berrinches en el Súper',
    value: '(Valor 17€)'
  }, {
    text: 'Bono GRATIS: Diccionario de Frases Exactas',
    value: '(Valor 17€)'
  }];
  return <section id="pricing" className="py-12 px-4 bg-white" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        {/* Emotional Closing Image */}
        <div className="rounded-2xl overflow-hidden mb-12 shadow-lg" data-id="element-16">
          <img src="https://cdn.magicpatterns.com/uploads/h2XaGx1T2HgR62iWHrLdyZ/imagen_3.png" alt="Madre e hijo abrazados - recuperando la conexión" className="w-full h-auto object-cover" data-id="element-17" />
        </div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-10 border border-gray-100 shadow-sm" data-id="element-18">
          <h2 className="text-2xl md:text-3xl font-bold text-deep-blue mb-8 text-center" data-id="element-19">
            Todo lo que necesitas para recuperar la paz hoy
          </h2>

          <ul className="flex flex-col gap-4 mb-8" data-id="element-20">
            {items.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-21">
                <CheckCircle2 className="w-6 h-6 text-mint flex-shrink-0 mt-0.5" data-id="element-22" />
                <span className="text-gray-800 font-medium text-lg" data-id="element-23">
                  {item.text}{' '}
                  <span className="text-gray-500 font-normal text-base" data-id="element-24">
                    {item.value}
                  </span>
                </span>
              </li>)}
          </ul>

          <div className="text-center mb-8 pt-6 border-t border-gray-200" data-id="element-25">
            <p className="text-lg text-gray-500 line-through mb-2 font-medium" data-id="element-26">
              Valor Total 61€
            </p>
            <p className="text-4xl md:text-5xl font-black text-red-500" data-id="element-27">
              Hoy solo 6,95€
            </p>
          </div>

          <div className="flex justify-center" data-id="element-28">
            <Button onClick={goToCheckout} className="animate-pulse-soft w-full text-lg py-4" data-id="element-29">
              DESCARGAR MANUAL + 2 BONOS AHORA (6,95€)
            </Button>
          </div>
        </div>
      </div>
    </section>;
}